








































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import { UpdateOrganization } from "@/api/lab-base-api-client";
import CTooltip from "@/components/CTooltip.vue";
import TooltipModule from "@/store/tooltip";
import AuthModule from "@/store/auth";
import OrganizationAdminsApi from "@/services/OrganizationAdmins";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
    CTooltip,
  },
})
export default class ORegisterInfoEdit extends CheckOrganizationAdminLogin {
  // 各フォームの初期値
  private form: UpdateOrganization = {
    name: "",
  };

  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private mounted() {
    this.fetch();
  }

  // アカウント情報編集ページで表示するデータの取得
  private fetch() {
    if (this.me) {
      this.form.name = this.me.name;
    }
  }

  private async updateOrganizationProfile() {
    if (!this.me) {
      return;
    }
    await OrganizationAdminsApi.instance.updateOrganizationAdminByUuid(this.me.uuid, this.form);
  }

  private async submit() {
    try {
      await this.updateOrganizationProfile();
      this.$router.push({ name: "ORegisterInfoEditComp" });
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      console.log(err);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }
}
